import { render, staticRenderFns } from "./CustomSelector.vue?vue&type=template&id=2c2ecd86&"
import script from "./CustomSelector.vue?vue&type=script&lang=js&"
export * from "./CustomSelector.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports